import { useTranslation } from 'react-i18next';
import { ToolCallDataList } from './ToolCallDataList';
import { type ParsedError } from './tool-call-utils';

interface ToolCallErrorProps {
  parsedResult: ParsedError;
}
export function ToolCallError({ parsedResult }: ToolCallErrorProps) {
  const { t } = useTranslation('prince');
  return (
    <ToolCallDataList
      items={[
        {
          label: t('toolCalls.error'),
          value: parsedResult.errors
            .filter(error => error !== undefined && error !== null)
            .map(error => {
              if (!error) return '';
              if (typeof error === 'string') return error;
              if (typeof error === 'object') {
                const hasStatusCode = 'statusCode' in error;
                const hasMessage = 'message' in error;
                if (hasStatusCode && hasMessage) return `${error.statusCode} => ${error.message}`;
                if (hasMessage) return error.message;
                if (hasStatusCode) return error.statusCode;
              }

              return JSON.stringify(error);
            })
            .join('\n'),
        },
      ]}
    />
  );
}
